module.exports = __webpack_public_path__ + "static/media/tickcheck.907c4a46.svg";